import ReactDOM from "react-dom";
import { Navigate, Route, Routes, unstable_HistoryRouter as HistoryRouter } from "react-router-dom";

import { AdminTab } from "@/Administration/Components/AdminTab";
import { CalendarTab } from "@/Appointments/Components/Calendar/CalendarTab";
import { SchedulingTab } from "@/Appointments/Components/Scheduling/SchedulingTab";
import { BillingTab } from "@/Billing/Components/BillingTab";
import { ApiSettings } from "@/Common/Api/ApiSettings";
import { Empty } from "@/Common/Components/Empty";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { NavStore } from "@/Common/Stores/NavStore";
import { OverlayStore } from "@/Common/Stores/OverlayStore";
import { RouterHistory } from "@/Common/Utilities/Router/RouterHistory";
import { CommunicationsTab_OptimizedV2 } from "@/Communications/Components/CommunicationsTab_OptimizedV2";
import { DocumentsTab } from "@/Documents/Components/DocumentsTab";
import { CacheStore } from "@/Globals/Stores/CacheStore";
import { SessionStore } from "@/Globals/Stores/SessionStore";
import { LabsTab } from "@/Labs/Components/LabsTab";
import { ListsTab } from "@/Lists/Components/ListsTab";
import { PharmacyOrdersTab } from "@/PharmacyOrders/Components/PharmacyOrdersTab";
import { PortfolioTab } from "@/Portfolio/Components/PortfolioTab";
import { PrescriptionRenewalsTab } from "@/PrescriptionRenewals/Components/PrescriptionRenewalsTab";
import { ReportingTab } from "@/Report/Components/ReportingTab";
import { SettingsTab } from "@/Settings/Components/SettingsTab";
import { ClinicSettingsLoader } from "../EntryPoints/MyleApp/ClinicSettingsLoader";
import { ExternalSignIn } from "../EntryPoints/MyleApp/ExternalSignIn";
import { HomeTab } from "../EntryPoints/MyleApp/HomeTab";
import { LoginPage } from "../EntryPoints/MyleApp/LoginPage";
import { Main } from "../EntryPoints/MyleApp/Main";
import { PersonTab } from "../EntryPoints/MyleApp/PersonTab";
import { ReLoginPage } from "../EntryPoints/MyleApp/ReLoginPage";
import { ErrorBoundary } from "../ErrorBoundary/ErrorBoundary";

interface PossibleRoute {
    path: string;
    component: typeof React.Component | ((props: object) => JSX.Element);
}

class MyleApp {
    private readonly protectedRoutes: PossibleRoute[] = [
        {
            path: "myle",
            component: HomeTab
        },
        {
            path: "calendar",
            component: CalendarTab
        },
        {
            path: "patients",
            component: PersonTab
        },
        {
            path: "communications_optimizedv2",
            component: CommunicationsTab_OptimizedV2
        },
        {
            path: "documents",
            component: DocumentsTab
        },
        {
            path: "billing",
            component: BillingTab
        },
        {
            path: "results",
            component: LabsTab
        },
        {
            path: "scheduling",
            component: SchedulingTab
        },
        {
            path: "affectation",
            component: Empty
        },
        {
            path: "administration",
            component: AdminTab
        },
        {
            path: "lists",
            component: ListsTab
        },
        {
            path: "portfolio",
            component: PortfolioTab
        },
        {
            path: "settings",
            component: SettingsTab
        },
        {
            path: "reporting",
            component: ReportingTab
        },
        {
            path: "prescriptionrenewals/*",
            component: PrescriptionRenewalsTab
        },
        {
            path: "orders/*",
            component: PharmacyOrdersTab
        },
        {
            path: "*",
            component: HomeTab
        }
    ];
    private timer = null;

    public Start(elementID: string, rootPathArg: string = null): void {
        if (rootPathArg && rootPathArg.length > 0) {
            window.rootPath = rootPathArg;
            window.baseURI = baseURI + rootPath;
        }

        window.apiSettings = new ApiSettings(baseURI);
        window.navStore = NavStore.createSingleton();
        window.cacheStore = CacheStore.createSingleton();
        window.sessionStore = SessionStore.createSingleton();
        window.overlayStore = OverlayStore.createSingleton();

        ReactDOM.render(
            <ErrorBoundary>
                <HistoryRouter history={RouterHistory} basename={window.rootPath}>
                    <Routes>
                        <Route element={<ClinicSettingsLoader />}>
                            <Route path="" element={<LoginPage />} />
                            <Route path="login" element={<ReLoginPage />} />
                        </Route>
                        <Route path="external-login" element={<ExternalSignIn />} />
                        {this.protectedRoutes.map(route => (
                            <Route
                                key={route.path}
                                path={route.path}
                                element={(
                                    <RequireAuth path={route.path}>
                                        <Main>
                                            <route.component />
                                        </Main>
                                    </RequireAuth>
                                )}
                            />
                        ))}
                    </Routes>
                </HistoryRouter>
            </ErrorBoundary>,
            document.getElementById(elementID)
        );

        $(window).resize(this.computeResize);
    }

    // TODO: rewrite using flexbox
    private computeResize(): void {
        clearTimeout(this.timer);

        this.timer = window.setTimeout(
            () => {
                // Vertical Adjustments
                var elem = $("#posref");
                var fxdHeightElement = $(".fxheight");

                var footer = $(".ws-footer");
                var tabheader = $(".myle-page-tab-header");
                var footerHeight = footer.length === 0 ? 0 : footer.outerHeight();
                var tabheaderHeight = tabheader.length === 0 ? 0 : tabheader.outerHeight();
                var headerHeight = $(".myle-page-header").outerHeight();

                if (footerHeight == null)
                    footerHeight = 0;
                if (headerHeight == null)
                    headerHeight = 0;
                if (tabheaderHeight == null)
                    tabheaderHeight = 0;

                var winOuterHeight = $(window).outerHeight() - 51; // -51 prevent the double scrolling of the entirepage
                var winHeight = winOuterHeight - headerHeight - tabheaderHeight; // -50

                let fitOutterHeight = $(".fitWindowOuterHeight");
                fitOutterHeight.each(function() {
                    let myElem = $(this);
                    let hvar = +myElem.attr("data-fitWindowOuterHeightAdjust");
                    if (isNaN(hvar))
                        hvar = 0;
                    myElem.css("height", (winOuterHeight + hvar) + "px");
                });

                if (elem.length) {
                    var maxScroll = (winHeight - footerHeight); // headerHeight
                    $(".ws-scrollable").css("max-height", maxScroll + "px");
                    $(".ws-scrollable").css("min-height", maxScroll + "px");
                }

                fxdHeightElement.each(function() {
                    var fxd = $(this);
                    var hvar = +fxd.attr("data-hvar");
                    if (isNaN(hvar))
                        hvar = 0;
                    var maxScroll = (winHeight - footerHeight) + hvar; // headerHeight

                    fxd.css("height", maxScroll + "px");
                    var elemMinHeight = fxd.css("min-height");
                    try {
                        // Apply Minimum Width if necessary
                        if (elemMinHeight != null && elemMinHeight.endsWith("px") && Number.parseInt(elemMinHeight.replace("px", "")) > maxScroll)
                            fxd.css("height", elemMinHeight);
                    }
                    catch (ex) { }

                    var scrollableElements = fxd.find(".scrollable");
                    scrollableElements.each(function() {
                        var elem = $(this);
                        var hvar = +elem.attr("data-hvar");
                        if (isNaN(hvar))
                            hvar = 0;
                        var displacement = elem.position().top - fxd.position().top;
                        if (isNaN(displacement))
                            displacement = 0;
                        if (displacement < 0)
                            displacement = 0;
                        elem.css("max-height", (maxScroll - displacement - hvar) + "px");
                        elem.css("min-height", (maxScroll - displacement - hvar) + "px");
                    });
                    fxd.find(".fixed").each(function() {
                        var elem = $(this);
                        elem.css("height", maxScroll + "px");
                    });
                    fxd.find(".fullscreen").each(function() {
                        var elemfs = $(this);
                        var hvarfs = +elemfs.attr("data-heightCorrection");
                        if (isNaN(hvarfs))
                            hvarfs = 0;

                        var c_winOuterHeight = winOuterHeight + 25; // Remove part of the -51 because we are dealing with popups absolute and dont seem to have the -51 issue
                        elemfs.css("height", (c_winOuterHeight + hvarfs) + "px");
                    });
                });
            },
            10
        );
    }
}

// enforce authentication and permissions
function RequireAuth(props: { children: JSX.Element, path: string }): JSX.Element {
    let result: JSX.Element;
    let deniedPath: string = "";

    const path = props.path.replace(/\/\*$/, "");
    if (!sessionStore.isAuthenticated()) {
        // do not redirect directly to the patient tab, patient data needs to be loaded beforehand, etc.
        deniedPath = path.toLowerCase() === "patients" ? "" : path;

        result = <Navigate to="/" />;
    }
    else if (!sessionStore.hasPermissionForPath(path)) {
        result = <Navigate to="myle" />;
    }
    else if (sessionStore.isSignInRequired()) {
        result = <Navigate to="login" />;
    }
    else {
        result = props.children;
    }

    navStore.convertAndSetCurrentTabNameFromRoutePath(path);
    sessionStore.dispatch(
        LocalOperations.Router.Route_Change,
        {
            navigationPath: path,
            deniedPath: deniedPath
        },
        50
    );

    return result;
}

export { MyleApp };
